import type React from 'react';

import Link from '@/components/Link/Link';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './ArticleCard.style';

interface ArticleCardProps {
  title: string;
  body?: string;
  readMoreCta: string;
  readMoreUrl: string;
}

const ArticleCard: React.FC<ArticleCardProps> = ({
  title,
  body,
  readMoreCta,
  readMoreUrl,
}) => {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  return (
    <div className={classes.card}>
      <div className={cx(globalClasses.h4, classes.cardTitle)}>{title}</div>
      {body && (
        <div className={cx(globalClasses.body, classes.cardDescription)}>
          {body}
        </div>
      )}
      <Link
        className={cx(globalClasses.bodyHyperlink, classes.cardLink)}
        href={readMoreUrl}
      >
        {readMoreCta}
      </Link>
    </div>
  );
};

export default ArticleCard;
